const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const MailSetting = () => import(/* webpackChunkName: "mail" */ './view/edit.vue');

export const ROUTE_NAME_MAIL = {
    SETTING: 'MailSetting'
} as const;

export default [
    {
        path: '/app/:appId/mail',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_MAIL.SETTING,
                component: MailSetting,
                meta: { requiresAuth: true }
            }
        ]
    }
];
